import logIt from "../../../logIt";
import GlobalVariables from "../GlobalVariables";

/**
 * Parses company CallConnect/Office hours raw text and converts into valid html as per design
 * @param {any} msgText
 */
const parseCompanyHours = function (msgText, matches, isRdTheme) {
    let messageTemplate = matches.prefix ? matches.prefix : ''; // to return



    // mock
    // msgText = 'Sunday: Closed, Monday: 9:00 AM-06:00 PM, Tuesday: 9:00 AM-06:00 PM, Wednesday: 9:00 AM-06:00 PM, Thursday: 9:00 AM-06:00 PM, Friday: 9:00 AM-05:00 PM, Saturday: Closed';
    const model = [
        // { order:5, day: 'Saturday', timeFrom: '9:00 AM', timeTo: '11:00 PM' }
    ];
    const days = {
        Monday: 0,
        Tuesday: 1,
        Wednesday: 2,
        Thursday: 3,
        Friday: 4,
        Saturday: 5,
        Sunday: 6
    };
    // 1- start preparing days model data
    const arr = matches.officeHrs;
    arr.forEach((item, index) => {
        var item = item.replace(/,\s*$/, ''); // replace last coma or space if found
        logIt(`OH::${item}`);
        // grab one day & time and split its parts
        const firstIndexOfColon = item.indexOf(':');
        const day = item.substring(0, firstIndexOfColon).trim();
        const timing = item.substring(firstIndexOfColon + 1).trim();
        const fromTo = timing.split('-');
        const fromTime = (fromTo && fromTo.length > 0 ? fromTo[0] : '').trim();
        const toTime = (fromTo && fromTo.length > 1 ? fromTo[1] : '').trim();
        // apply regex to validate day and time parts
        let validDay;
        let validFromTime;
        let validToTime;
        try {
            validDay = day.match(GlobalVariables.regexWeekDay) ? day : '';
            validFromTime = fromTime.match(GlobalVariables.regexTime) ? fromTime : '';
            validToTime = toTime.match(GlobalVariables.regexTime) ? toTime : '';
        } catch (e) {
            logIt(`OH::error parsing company hours:${e.message}`);
        }
        if (validDay !== '') {
            // if a day is either missing or invalid, we should miss it in the schedule display
            const order = days[validDay]; // extract the day index

            // one model created, store it
            model.push({
                order,
                day: validDay,
                timeFrom: validFromTime,
                timeTo: validToTime
            });
        }
    });
    if (model.length == 0) {
        return messageTemplate;
    }
    // sort by day index if found out of order
    model.sort((a, b) => a.order - b.order);
    // 2- now create html for the complately formatted message
    // if not RD, simply list office hours w/o any formatting
    if (!isRdTheme) {
        // messageTemplate += '<span><ul style="list-style: none;padding-left:5px;line-height: 20px;">';
        model.forEach((item, index) => {
            logIt(`OH::processing day:${index}`);

            if (item.timeFrom === '' && item.timeTo === '') {
                messageTemplate += `${item.day}\t\t: Closed`; // if a day is missing office hours, we assum it CLOSED on that day
            } else {
                messageTemplate += `${item.day}\t\t: ${item.timeFrom} - ${item.timeTo}`;
            }
            if (index < model.length - 1) {
                messageTemplate = `${messageTemplate}, `;
            }
        });
        // messageTemplate += '</ul></span>';
    } else {
        // for RD, we have a design to incorporate
        messageTemplate += '<span class="livechat_hours_details"><ul class="livechat_days">';
        model.forEach((item, index) => {
            messageTemplate += `<li>${item.day}</li>`;
        });
        messageTemplate += '</ul > <ul class="livechat_hours_seprator">';
        model.forEach((item, index) => {
            messageTemplate += '<li>-</li>';
        });
        messageTemplate += '</ul > <ul class="livechat_Working_hours">';
        model.forEach((item, index) => {
            if (item.timeFrom === '' && item.timeTo === '') {
                messageTemplate += '<li> Closed </li>'; // if a day is missing office hours, we assum it CLOSED on that day
            } else {
                messageTemplate += `<li>${item.timeFrom} - ${item.timeTo}</li>`;
            }
        });
        messageTemplate += '</ul></span>';
    }
    return messageTemplate;
};
export default parseCompanyHours;
